/* mf-pdp-d.js - the "Új vásárlódoboz (D)" product page (Theme settings > Termékoldal = D), RO 2026-10-07.
   D is C plus the approved new buy box. Loaded by snippets/mf-pdp-c.liquid right after assets/mf-pdp-c.js, only in
   D mode (the section then carries .mfc.mfpd). Like C, nothing here sells on its own: every control drives C's
   controls, which drive the live ones, so the cart, Function prices, the glossy merge, MagSafe, the gallery and the
   tracking stay the live code.
     - type cards: a radiogroup of portrait cards over C's type list (window.__mfPdpC.types()); a tap is C's
       choose(i) (the synthetic click on the live card); C's dropdown stays in the DOM, unseen, while 2+ types exist
     - sale marks: only while the live hero shows a compare-at cut ('-X%' on the gallery stage and on each type card
       whose live card has a struck price)
     - protector: two side-by-side cards over C's two folie rows (Pro-Shield, NanoGlass), ONE AT A TIME: a tap ticks
       that row and unticks the other, a second tap unticks it; every row whose state changed gets a 'change', so C's
       own change path (the live card, the CTA, the float bar, the measurement) does the rest
   Inherited from C since 2026-10-07 (owner), nothing of it here any more: the 1+1 strip as a lilac block right under
   the hero price, and the green Mystery Cadou strip that toggles on a tap anywhere (assets/mf-pdp-c.js / .css). */
(function () {
  'use strict';
  var D = document, W = window;
  var root = D.querySelector('.pr.mfc.mfpd[data-pr]');
  var C = W.__mfPdpC;
  if (!root || root.__mfd || !C) { return; }
  root.__mfd = true;

  var cfg = {}, ccfg = {}, data = {};
  try { cfg = JSON.parse((D.querySelector('[data-mfpd-data]') || {}).textContent || '{}'); } catch (e0) {}
  try { ccfg = JSON.parse((D.querySelector('[data-mfc-data]') || {}).textContent || '{}'); } catch (e1) {}
  try { data = JSON.parse((D.querySelector('[data-pr-data]') || {}).textContent || '{}'); } catch (e2) {}
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function raf(fn) { var q = 0; return function () { if (q) { return; } q = W.requestAnimationFrame(function () { q = 0; fn(); }); }; }
  var KEY = /^[a-z0-9_:]{1,40}$/;
  function step1(n) { if (KEY.test(n) && C.step1) { C.step1(n); } }

  /* money: the section's formatter (as C), and its reverse for the texts that formatter wrote */
  var fmt = String(data.moneyFormat || '');
  var amountRe = new RegExp('\\{\\{\\s*amount[^}]*\\}\\}');
  var noDec = /no_decimals/.test((fmt.match(amountRe) || [''])[0]);
  function money(c) {
    var v = (c || 0) / 100;
    var s = noDec ? String(Math.round(v)) : ((v % 1 === 0) ? v.toFixed(0) : v.toFixed(2).replace('.', ','));
    return amountRe.test(fmt) ? fmt.replace(amountRe, s) : s + ' RON';
  }
  function cents(t) {
    var x = String(t || '').replace(/[^\d.,]/g, '');
    if (!x) { return 0; }
    var p = x.split(',');
    return (parseInt(p[0].replace(/\./g, ''), 10) || 0) * 100 + (p.length > 1 ? (parseInt((p[1] + '00').slice(0, 2), 10) || 0) : 0);
  }
  var TICK = '<span class="mfpd-cb" aria-hidden="true"><svg viewBox="0 0 16 16"><path d="M3.5 8.3 6.6 11.3 12.6 4.9"/></svg></span>';
  var DROP = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.5v7M3 5.8 6 8.8l3-3M2 10.8h8"/></svg>';

  /* ═══ type cards ═══ */
  var tWrap = $('[data-mfc-type]');
  var tSel = $('[data-mfc-tsel]');
  var tc = null, row = null, sig = '';
  /* the cut a card's own live price shows (struck original vs the price), 0 when none */
  function offOf(t) {
    if (!t || !t.was) { return 0; }
    var w = cents(t.was), n = cents(t.now);
    return (w > n && n > 0) ? Math.round((1 - n / w) * 100) : 0;
  }
  /* the live list hides sold-out types while any type ships; when none does it shows them all with the sold-out
     label for a price - those cards fade and do not pick */
  function isOut(t) { return !!t && (!!t.card.disabled || (!!cfg.soldOut && t.now === cfg.soldOut)); }
  /* the live card's pill in any style (C's info() reads only the ink/accent ones; 'Cel mai rezistent' is outline) */
  function badgeOf(t) {
    var b = t && t.card ? t.card.querySelector('.pr-type__badge') : null;
    return b ? String(b.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function bigImg(u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=300') : u; }
  function card(t, i) {
    var off = offOf(t), out = isOut(t), bd = badgeOf(t);
    var fin = t.fin ? (t.gloss ? (ccfg.finL || 'Finisaj lucios') : (ccfg.finM || 'Finisaj mat')).toLowerCase() + ', ' : '';
    var lab = t.name + ', ' + fin + t.meter + ' ' + (ccfg.drop || '') + ', ' + (out ? t.now : (t.was ? t.now + ' ' + (cfg.inLoc || '') + ' ' + t.was : t.now)) +
      (off ? ', -' + off + '%' : '') + (bd ? ', ' + bd : '');
    return '<button type="button" class="mfpd-tc__card" role="radio" aria-checked="' + (t.on ? 'true' : 'false') + '" tabindex="-1"' +
      (out ? ' aria-disabled="true"' : '') + ' aria-label="' + esc(lab) + '" data-i="' + i + '">' +
      '<span class="mfpd-tc__pic">' + (bd ? '<span class="mfpd-tc__tag">' + esc(bd) + '</span>' : '') +
      (off ? '<span class="mfpd-off mfpd-tc__off">-' + off + '%</span>' : '') +
      (t.img ? '<img src="' + esc(bigImg(t.img)) + '" alt="" width="150" height="300" loading="lazy">' : '') + '</span>' +
      '<span class="mfpd-tc__t"><span class="mfpd-tc__n">' + esc(t.name) + '</span>' +
      '<span class="mfpd-tc__m">' + (t.fin ? '<span class="mfc-fin' + (t.gloss ? ' mfc-fin--gl' : '') + '">' + esc(t.gloss ? ccfg.finBL : ccfg.finBM) + '</span>' : '') + DROP + esc(t.meter) + '</span>' +
      '<span class="mfpd-tc__p">' + esc(t.now) + (t.was && !out ? '<s>' + esc(t.was) + '</s>' : '') + '</span></span></button>';
  }
  /* one tab stop: the checked card, else the first card that picks */
  function tabStop() {
    var cs = $$('.mfpd-tc__card', row), on = cs.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0];
    if (!on) { on = cs.filter(function (c) { return !c.hasAttribute('aria-disabled'); })[0] || cs[0]; }
    cs.forEach(function (c) { c.tabIndex = c === on ? 0 : -1; });
    return on;
  }
  function renderCards() {
    if (!tc) { return; }
    var T = C.types() || [];
    var multi = T.length > 1;
    tWrap.classList.toggle('mfpd-has-tc', multi);
    tc.hidden = !multi;
    if (!multi) { if (sig) { row.innerHTML = ''; sig = ''; } return; }
    var s = JSON.stringify(T.map(function (t) { return [t.name, badgeOf(t), t.gloss, t.fin, t.meter, t.was, t.now, t.img, t.on, isOut(t)]; }));
    if (s === sig) { return; }
    sig = s;
    var hadFocus = row.contains(D.activeElement);
    var sl = row.scrollLeft;
    row.innerHTML = T.map(card).join('');
    row.classList.toggle('is-n2', T.length === 2);
    tc.classList.toggle('is-sale', T.some(function (t) { return offOf(t) > 0; }));
    if (row.scrollLeft !== sl) { row.scrollLeft = sl; }
    var on = tabStop();
    if (hadFocus && on) { try { on.focus({ preventScroll: true }); } catch (eF) { on.focus(); } }
    fit();
    paintEnd();
  }
  /* desktop: name and price share a line only while every name fits beside its price; else the price drops to its
     own line (.is-stack, as the sale layout) */
  var mqD = W.matchMedia ? W.matchMedia('(min-width: 1000px)') : null;
  function fit() {
    if (!tc || tc.hidden) { return; }
    var was = tc.classList.contains('is-stack');
    tc.classList.remove('is-stack');
    var over = !!(mqD && mqD.matches) && $$('.mfpd-tc__n, .mfpd-tc__m', row).some(function (e) { return e.scrollWidth > e.clientWidth + 1; });
    tc.classList.toggle('is-stack', over);
    if (over !== was) { paintEnd(); }
  }
  function pick(btn) {
    if (!btn || btn.hasAttribute('aria-disabled')) { return; }
    if (btn.getAttribute('aria-checked') === 'true') { return; }
    C.choose(+btn.getAttribute('data-i'));
  }
  /* measurement: tc_swipe = the first USER scroll of the row (a touch/pointer drag or a wheel within the last second
     - a re-render, a focus scroll or a re-snap is not a swipe); tc_end = the last card seen at >= 60% in a row that
     scrolls (checked when the row comes into view and after every user scroll; a row that fits never sends it) */
  var userAt = 0, swiped = false, inView = false;
  function paintEnd() {
    if (!row || !inView || row.scrollWidth <= row.clientWidth + 1) { return; }
    var last = row.lastElementChild;
    if (!last) { return; }
    var r = last.getBoundingClientRect(), rr = row.getBoundingClientRect();
    var seen = Math.max(0, Math.min(r.right, rr.right) - Math.max(r.left, rr.left));
    if (r.width && seen >= 0.6 * r.width) { step1('pdpc:tc_end'); }
  }
  if (tWrap && tSel && C.types && C.choose) {
    tc = D.createElement('div');
    tc.className = 'mfpd-tc';
    tc.hidden = true;
    row = D.createElement('div');
    row.className = 'mfpd-tc__row';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-labelledby', 'mfc-tlbl');
    tc.appendChild(row);
    tSel.parentNode.insertBefore(tc, tSel.nextSibling);
    renderCards();
    if (C.onTypes) { C.onTypes(renderCards); }
    var fitR = raf(fit);
    if (W.ResizeObserver) { new ResizeObserver(fitR).observe(row); } else { W.addEventListener('resize', fitR); }
    if (D.fonts && D.fonts.ready) { D.fonts.ready.then(fitR); }
    row.addEventListener('click', function (e) {
      pick(e.target && e.target.closest ? e.target.closest('.mfpd-tc__card') : null);
    });
    row.addEventListener('keydown', function (e) {
      var cs = $$('.mfpd-tc__card', row).filter(function (c) { return !c.hasAttribute('aria-disabled'); });
      var n = cs.length, i = cs.indexOf(D.activeElement), to = -1;
      if (!n) { return; }
      if (i < 0) { i = Math.max(0, cs.indexOf(row.querySelector('[aria-checked="true"]'))); }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { to = (i + 1) % n; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { to = (i + n - 1) % n; }
      else if (e.key === 'Home') { to = 0; }
      else if (e.key === 'End') { to = n - 1; }
      if (to < 0) { return; }
      e.preventDefault();
      try { cs[to].focus(); } catch (eF) {}
      pick(cs[to]);
    });
    var mark = function () { userAt = Date.now(); };
    row.addEventListener('touchmove', mark, { passive: true });
    row.addEventListener('wheel', mark, { passive: true });
    row.addEventListener('pointermove', function (e) { if (e.buttons) { mark(); } }, { passive: true });
    if (W.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        inView = en.some(function (x) { return x.isIntersecting; });
        if (inView) { paintEnd(); }
      }, { threshold: 0.6 }).observe(row);
    } else { inView = true; }
    row.addEventListener('scroll', raf(function () {
      if (!userAt || Date.now() - userAt > 1000) { return; }
      if (!swiped) { swiped = true; step1('pdpc:tc_swipe'); }
      paintEnd();
    }), { passive: true });
  }

  /* ═══ the hero price: the sale marks while it shows a compare-at cut (the 1+1 strip under it is C's now) ═══ */
  var hero = $('[data-pr-heroprice]');
  var media = $('[data-pr-media-root]') || $('.pr-media');
  var galOff = null;
  if (media) {
    galOff = D.createElement('span');
    galOff.className = 'mfpd-off mfpd-galoff';
    galOff.setAttribute('aria-hidden', 'true');
    galOff.hidden = true;
    var st = $('[data-pr-stage]', media);
    media.insertBefore(galOff, st || media.firstChild);
  }
  function paintSale() {
    var was = hero ? hero.querySelector('[data-hp-was]') : null;
    var off = hero ? hero.querySelector('[data-hp-off]') : null;
    var on = !!(hero && !hero.hidden && was && !was.hidden && String(was.textContent || '').trim() && off && String(off.textContent || '').trim());
    root.classList.toggle('mfpd-sale', on);
    if (galOff) {
      galOff.hidden = !on;
      var t = on ? String(off.textContent || '').trim() : '';
      if (galOff.textContent !== t) { galOff.textContent = t; }
    }
  }
  if (hero) {
    paintSale();
    new MutationObserver(raf(paintSale)).observe(hero, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  }

  /* ═══ protector: two cards over C's two folie rows (each row: data-k / data-was / data-now / data-img, the name in
     [data-mfc-prot-n], its own checkbox). C has already dropped a row whose live card is missing. ═══ */
  var rows = $$('[data-mfc-prot]');
  function liveUp(k) { return root.querySelector('[data-pr-up][data-pr-up-kind="' + k + '"]'); }
  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function rowCb(r) { return r ? $('[data-mfc-prot-cb]', r) : null; }
  function rowOf(k) { return rows.filter(function (r) { return r.getAttribute('data-k') === k; })[0] || null; }
  var pf = null;
  /* a card is checked exactly while its row's checkbox is */
  function paintPc() {
    if (!pf) { return; }
    $$('.mfpd-pc', pf).forEach(function (c) {
      var cb = rowCb(rowOf(c.getAttribute('data-k')));
      c.setAttribute('aria-checked', cb && cb.checked ? 'true' : 'false');
    });
  }
  rows = rows.filter(function (r) { return !!rowCb(r); });
  if (rows.length) {
    var cardsH = rows.map(function (r) {
      var k = r.getAttribute('data-k'), lu = liveUp(k);
      var reco = lu ? txt(lu.querySelector('.pr-up__reco')) : '';
      if (!reco && k === 'ps') { reco = cfg.reco || ''; }
      var sh = (lu ? txt(lu.querySelector('.pr-up__desc')) : '') || (k === 'ps' ? cfg.psS : cfg.ngS) || '';
      var was = parseInt(r.getAttribute('data-was'), 10) || 0, now = parseInt(r.getAttribute('data-now'), 10) || 0;
      var nm = txt($('[data-mfc-prot-n]', r));
      var pr = '+' + money(now), wr = was > now ? money(was) : '';
      var img = String(r.getAttribute('data-img') || '').replace(/([?&])width=\d+/, '$1width=300');
      return '<button type="button" class="mfpd-pc" role="checkbox" aria-checked="false" data-k="' + esc(k) + '" aria-label="' +
        esc(nm + (reco ? ' (' + reco + ')' : '') + ', ' + sh + ', ' + pr + (wr ? ' ' + (cfg.inLoc || '') + ' ' + wr : '')) + '">' +
        '<span class="mfpd-pc__pic">' + (img ? '<img src="' + esc(img) + '" alt="" width="150" height="150" loading="lazy">' : '') + '</span>' + TICK +
        '<span class="mfpd-pc__t"><span class="mfpd-pc__n">' + esc(nm) + (reco ? '<span class="mfpd-pc__tag">' + esc(reco) + '</span>' : '') + '</span>' +
        '<span class="mfpd-pc__s">' + esc(sh) + '</span>' +
        '<span class="mfpd-pc__p">' + esc(pr) + (wr ? '<s>' + esc(wr) + '</s>' : '') + '</span></span></button>';
    }).join('');
    pf = D.createElement('div');
    pf.className = 'mfpd-pf';
    pf.setAttribute('role', 'group');
    pf.setAttribute('aria-labelledby', 'mfpd-pfh');
    pf.innerHTML = '<p class="mfpd-pf__h" id="mfpd-pfh">' + esc(cfg.folH || '') + (cfg.folS ? ' <span>' + esc(cfg.folS) + '</span>' : '') + '</p>' +
      '<div class="mfpd-pf__row' + (rows.length < 2 ? ' is-one' : '') + '">' + cardsH + '</div>';
    rows[0].parentNode.insertBefore(pf, rows[0]);
    rows.forEach(function (r) { r.classList.add('mfpd-src'); });
    /* one at a time, a second tap unticks. C's rows are independent ticks, so D enforces the one-at-a-time rule
       itself: the other row is unticked first, then the tapped row flips; each checkbox whose state changed gets a
       bubbling 'change', and C's own change path (syncProt -> the live card, paintProt, paintCta, the float bar)
       does the rest. The 'pdpc:fol_<k>' key is booked by that C change path on tick-on, not here - one owner, so a
       D tap never books it twice. */
    pf.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.mfpd-pc') : null;
      if (!c) { return; }
      var tr = rowOf(c.getAttribute('data-k')), tcb = rowCb(tr);
      if (!tcb) { return; }
      var on = !tcb.checked;
      rows.forEach(function (r) {
        if (r === tr) { return; }
        var cb = rowCb(r);
        if (cb.checked) { cb.checked = false; cb.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      tcb.checked = on;
      tcb.dispatchEvent(new Event('change', { bubbles: true }));
      paintPc();
    });
    rows.forEach(function (r) { rowCb(r).addEventListener('change', paintPc); });
    paintPc();
  }

  /* QA hook */
  W.__mfPdpD = { render: renderCards, sale: paintSale };
})();
